import { render, staticRenderFns } from "./MonthlyRevenue.vue?vue&type=template&id=0a827e06"
import script from "./MonthlyRevenue.vue?vue&type=script&lang=js"
export * from "./MonthlyRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports